module.exports = __webpack_public_path__ + "img/tcj.ffad60fe.jpg";